import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

/**
 * Internal dependencies
 */
import usePrevious from '../use-previous';
/**
 * Hook that performs a shallow comparison between the preview value of an object
 * and the new one, if there's a difference, it prints it to the console.
 * this is useful in performance related work, to check why a component re-renders.
 *
 *  @example
 *
 * ```jsx
 * function MyComponent(props) {
 *    useWarnOnChange(props);
 *
 *    return "Something";
 * }
 * ```
 *
 * @param {Object} object Object which changes to compare.
 * @param {string} prefix Just a prefix to show when console logging.
 */

function useWarnOnChange(object) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Change detection';
  var previousValues = usePrevious(object);
  Object.entries(previousValues !== null && previousValues !== void 0 ? previousValues : []).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    if (value !== object[key]) {
      // eslint-disable-next-line no-console
      console.warn("".concat(prefix, ": ").concat(key, " key changed:"), value, object[key]);
    }
  });
}

export default useWarnOnChange;
//# sourceMappingURL=index.js.map